export default __webpack_public_path__ + "static/media/39634-cargo.4707e575.gif";